import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';

import { ReceiveMeetingRequestContext } from './receive-meeting-request-context.action';

export function receiveMeetingRequestContextReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<
        ActionType.COACHING__CA__RECEIVE_MEETING_REQUEST_CONTEXT,
        ReceiveMeetingRequestContext
    >,
): CaAnalysisDialogState {
    return {
        ...state,
        meetingRequestContext: action.payload.caMeetingRequestContext,
    };
}
